import React, { useReducer } from "react";

import { QuizSlideDataSequence } from "@natklok/interfaces/question.interface";
import { Action, questionsReducer } from "@natklok/reducers/questionsReducer";
import useDefaultSlideDatas from "@natklok/hooks/useDefaultSlideDatas";

export const SlideDataContext = React.createContext<{
  quizSlideDataSequence: QuizSlideDataSequence;
  questionsReducer: React.Dispatch<Action>;
}>({
  quizSlideDataSequence: [],
  questionsReducer: () => null,
});

export const SlideDataProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const defaultSlideDatas = useDefaultSlideDatas();
  const [slideDataList, setSlideDataList] = useReducer(questionsReducer, defaultSlideDatas);

  return (
    <SlideDataContext.Provider
      value={{
        quizSlideDataSequence: slideDataList,
        questionsReducer: setSlideDataList,
      }}
    >
      {children}
    </SlideDataContext.Provider>
  );
};
